// VFX: Slide Left Transition
// Category: slide-transition · Tags: transition, slide, smooth, jakub
// Scene slides out to left, new scene slides in from right.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

export default function TransitionSlideLeftSmooth300Ms() {
  const frame = useCurrentFrame();
  const { width, height, fps } = useVideoConfig();
  const progress = spring({ frame, fps, config: { damping: 18, stiffness: 120, mass: 0.6 } });
  const offsetA = interpolate(progress, [0, 1], [0, -width]);
  const offsetB = interpolate(progress, [0, 1], [width, 0]);

  return (
    <AbsoluteFill style={{ background: "#0a0e1a", overflow: "hidden" }}>
      <div style={{
        position: "absolute", width, height, transform: `translateX(${offsetA}px)`,
        background: "linear-gradient(135deg, #a855f7 0%, #06b6d4 100%)",
        display: "flex", justifyContent: "center", alignItems: "center",
        color: "#f8fafc", fontSize: 96, fontWeight: 800, fontFamily: "sans-serif",
      }}>A</div>
      <div style={{
        position: "absolute", width, height, transform: `translateX(${offsetB}px)`,
        background: "linear-gradient(135deg, #f97316 0%, #ef4444 100%)",
        display: "flex", justifyContent: "center", alignItems: "center",
        color: "#f8fafc", fontSize: 96, fontWeight: 800, fontFamily: "sans-serif",
      }}>B</div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
